module.exports = __webpack_public_path__ + "img/ai-img-keyboard.8b1b40dd.png";